const isBrowser: boolean = typeof window !== 'undefined';

const isJobPage =
  isBrowser && (window.location.hostname.includes('pageuppeople') || window.location.hostname.includes('jobs.'));

export default isJobPage;
